// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"479":"45af7db6","952":"ba1959cd","1531":"0f4e792a","2337":"ae4474d4","2443":"62169c31","4215":"6de1f485","5656":"5af95cd7","6012":"2e941ac0","6092":"bf5ddb17","6453":"cb1bd2be","8099":"4c8cbf61"}[chunkId] + ".chunk.js";
};